import React from "react";
import { Container, BodyWrapper, Wrapper } from "pages/Admin/Users/UsersStyled";
import UserTable from "./UserTable";

export const Users = () => {
  return (
    <Container>
      <Wrapper>
        <div className="inbox-table">
          <BodyWrapper>
            <UserTable />
          </BodyWrapper>
        </div>
      </Wrapper>
    </Container>
  );
};

export default Users;
